import CollectionList from 'components/CollectionList/CollectionList'
import PageSection from 'components/shared/PageSection/PageSection'
import PropTypes from 'prop-types'
import { withNamespaces } from 'react-i18next'

import './PathsSection.scss'

const PathsSection = ({ t, locale, gtm = {} }) => {
  return (
    <>
      <PageSection
        title={t('homepage.paths.title')}
        description={t('homepage.paths.description')}
        className={'homepage-paths'}
      >
        <CollectionList
          homepageVariant
          locale={locale}
          gtm={{ ...gtm, label_prefix: 'Path:' }}
        />
      </PageSection>
    </>
  )
}

PathsSection.propTypes = {
  t: PropTypes.func.isRequired,
  locale: PropTypes.string.isRequired,
  gtm: PropTypes.object,
}

export { PathsSection }
export default withNamespaces('translations')(PathsSection)
